<template>
  <div class="container-fluid">
    <div class="row justify-content-center" v-if="withSponsorLine">
      <span class="col legal-item border-0" style="height:30px; background:#fff; color:#002a32">This app is kindly supported by <img class="p-2" src="@/assets/Philips.png" style="height:30px"></span>
    </div>
    <div class="row justify-content-center" v-if="withPrivacy">
      <a href="#/app/generalinfo/73f6ac55-2c23-4776-b55e-7a0839ba1bc0" class="col legal-item border-0 pb-1" >
        Privacy Policy
      </a>
      <a href="#/app/generalinfo/63f12ca1-124e-4c04-87df-1f76185c611b" class="col legal-item border-0 pb-1">
        Imprint
      </a>
    </div>
  </div>

</template>

<script>
import {
} from "@ionic/vue";
import { isPlatform } from '@ionic/vue';

export default {
  components: {
  },
  props:['withPrivacy', 'withSponsorLine'],
  data() {
    return {
      isDesktop: null,
    }
  },
  computed: {
  },
  methods: {
 
  
  },
  async created() {
    this.isDesktop= isPlatform('desktop');
  }
};
</script>
<style lang="scss">

.legal-item{
  height:25px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  border:none;
  font-size: 0.8rem;
  color: white;
}

</style>
